import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Aviso } from 'src/app/model/aviso.model';

import moment from "moment";
import { TipoAvisoEnum } from 'src/app/model/tipo-aviso-enum';

@Injectable({
  providedIn: 'root'
})
export class AvisoService extends FgiBackEndService<Aviso> {

  getNewEntity():Aviso {
    return new Aviso();    
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/avisos';
  }

  getAnexo(id:number) {
    return this.http.get(`${this.BASE_URL}/${id}/anexo`, { responseType: 'blob' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }
  
  // nao tem no BaseEntityService pra fazer override
  getAvisos(params?: any): any {
    return this.http.get(this.BASE_URL, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<Aviso>>;
  }

  getAvisosConfirmacao(cnpjAgente?: string, administrador?: boolean): Observable<any> {
    const ultimaSegunda: string = moment().isoWeekday(1).format('YYYYMMDD');
    
    let tipo = administrador ? TipoAvisoEnum.INFORME_ADMINISTRADOR : TipoAvisoEnum.AVISO_CONFIRMACAO;
    let dataCriacaoInicial = ultimaSegunda;
    let dataCriacaoFinal = ultimaSegunda;

    const parametros: any = {
      tipo: tipo,
      dataCriacaoInicial: dataCriacaoInicial,
      dataCriacaoFinal: dataCriacaoFinal,
    };
    if (cnpjAgente) {
      parametros.cnpjAgenteFinanceiro = cnpjAgente;
    }
    return this.http.get(this.BASE_URL, {params: parametros}).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  save(entity: Aviso, anexo?: File, options?: any): Observable<Aviso> {
    var formData =  new FormData();
    formData.append("aviso", JSON.stringify(entity));
    if (anexo) {
      formData.append("anexoAviso", anexo);
    }
    const url = `${this.BASE_URL}/` + (entity.id ? `${entity.id}/atualiza` : '');
    return this.http.post(url, formData, options).pipe(
      map(response => this.convertToType(response)),
      catchError((e) => this.handleError(e))) as Observable<Aviso>;
  }  

  desativa(id: number): Observable<Aviso> {
    return  this.http.post(`${this.BASE_URL}/${id}/desativa`, '').pipe(
      map(response => this.convertToType(response)),
      catchError((e) => this.handleError(e))) as Observable<Aviso>;
  }

}